import { useEffect, useState, useRef } from "react";
import { postAxios } from "../../util/apiCall";
import { today } from "../../util/formatDate";
import { mock, incomingApar } from "../../util/constant";
import { Html5Qrcode } from "html5-qrcode";
import axios from "axios";
import moment from "moment";

const KAD_KOSONG = { tgl: "", bln: "", thn: "" };

export const useChecksheetApar = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const html5QrCodeRef = useRef(null);

  const [type, setType] = useState();
  const [dateApar, setDateApar] = useState(today);
  const [supplier, setSupplier] = useState();
  const [kondisi, setKondisi] = useState();

  // tanggal kadaluarsa: 3 isian angka (tgl, bln, thn), default kosong
  const [kadaluarsa, setKadaluarsa] = useState(KAD_KOSONG);
  const [errorMsg, setErrorMsg] = useState("");

  const [checkListIncomingApar, setCheckListIncomingApar] = useState(() =>
    JSON.parse(JSON.stringify(incomingApar))
  );

  const [checkListApar, setCheckListApar] = useState(() =>
    JSON.parse(JSON.stringify(mock))
  );
  const [keterangan, setKeterangan] = useState();

  const [popUpKirimChecklist, setPopUpKirimChecklist] = useState(false);

  const [subMenu, setSubMenu] = useState("Riwayat");

  const [filterBulan, setFilterBulan] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );
  const [popUpChecksheet, setPopUpChecksheet] = useState(false);

  const [filterMesin, setFilterMesin] = useState("Pilih Apar");
  const [filterType, setFilterType] = useState("Checksheet");
  const [isReload, setIsReload] = useState(false);

  const [listRiwayat, setListRiwayat] = useState();

  const [filterLantai, setFilterLantai] = useState("1");
  const [listStatusApar, setListStatusApar] = useState();
  const [listApar, setListApar] = useState();

  // urutan noApar: "asc" = A-Z (1 → 59), "desc" = Z-A (59 → 1)
  const [sortApar, setSortApar] = useState("asc");

  // gabungkan tgl/bln/thn jadi YYYY-MM-DD (kosong kalau belum lengkap/tidak valid)
  const kadMoment = moment(
    `${kadaluarsa.thn}-${String(kadaluarsa.bln).padStart(2, "0")}-${String(
      kadaluarsa.tgl
    ).padStart(2, "0")}`,
    "YYYY-MM-DD",
    true
  );
  const tanggalKadaluarsa =
    kadaluarsa.thn.length === 4 && kadMoment.isValid()
      ? kadMoment.format("YYYY-MM-DD")
      : "";

  // Ref berisi nilai form terbaru, supaya callback scan QR tidak memakai
  // nilai lama (stale closure).
  const formRef = useRef({});
  formRef.current = {
    date: dateApar,
    type,
    supplier,
    kondisi,
    checklist: checkListIncomingApar,
    keterangan,
    kadaluarsa: tanggalKadaluarsa,
  };

  const checksheetRef = useRef([]);
  checksheetRef.current = checkListApar;

  useEffect(() => {
    setCheckListApar(JSON.parse(JSON.stringify(mock)));
    setCheckListIncomingApar(JSON.parse(JSON.stringify(incomingApar)));
    setKeterangan();
    setFilterBulan(moment().utcOffset("+0700").month() + 1);
    setFilterTahun(moment().utcOffset("+0700").year());
    setType();
    setDateApar(today);
    setSupplier();
    setKondisi();
    setKadaluarsa(KAD_KOSONG);
    setErrorMsg("");
  }, [subMenu]);

  const handleChangeIncomingApar = (index, event) => {
    let data = [...checkListIncomingApar];
    if (index === 8 || index === 7) {
      data[index][event.target.name] = Number(event.target.value);
      setCheckListIncomingApar(data);
    } else {
      if (data[index][event.target.name] === true) {
        data[index][event.target.name] = false;
      } else {
        data[index][event.target.name] = true;
      }
      setCheckListIncomingApar(data);
    }
  };

  // validasi sebelum popup scan dibuka
  const handleKirimInOut = () => {
    if (!type) {
      return setErrorMsg(
        "Pilih jenis In/Out dulu (Incoming, Pemakaian, atau Keluar)."
      );
    }

    if (type === "Incoming") {
      if (!kadaluarsa.tgl || !kadaluarsa.bln || !kadaluarsa.thn) {
        return setErrorMsg(
          "Tanggal kadaluarsa wajib diisi lengkap (tanggal, bulan, tahun)."
        );
      }
      if (!tanggalKadaluarsa) {
        return setErrorMsg(
          "Tanggal kadaluarsa tidak valid. Cek lagi tanggal, bulan, dan tahun (4 digit)."
        );
      }
      if (moment(tanggalKadaluarsa).isSameOrBefore(moment(dateApar), "day")) {
        return setErrorMsg("Tanggal kadaluarsa harus setelah tanggal In/Out.");
      }
    }

    setErrorMsg("");
    setPopUpKirimChecklist(true);
  };

  const stopScanner = () => {
    const html5QrCode = html5QrCodeRef.current;
    if (!html5QrCode) return;
    html5QrCode
      .stop()
      .then(() => html5QrCode.clear())
      .catch(() => {})
      .finally(() => {
        html5QrCodeRef.current = null;
      });
  };

  const handleScan = () => {
    if (popUpKirimChecklist) {
      if (!html5QrCodeRef.current) {
        html5QrCodeRef.current = new Html5Qrcode("qr");
      }

      const html5QrCode = html5QrCodeRef.current;

      const qrCodeSuccessCallback = async (decodedText) => {
        if (!decodedText) return;
        html5QrCode.pause();

        const f = formRef.current; // selalu nilai terbaru
        try {
          const { data } = await axios.post(
            `${process.env.REACT_APP_ENDPOINT}/inOutApar`,
            {
              tim: dataUser.tim,
              petugas: dataUser.name,
              name: decodedText,
              date: f.date,
              type: f.type,
              supplier: f.supplier,
              kondisi: f.kondisi,
              checklist: f.checklist,
              keterangan: f.keterangan,
              kadaluarsa: f.kadaluarsa,
            },
            {
              headers: {
                Authorization: `Bearer ${dataUser.auth}`,
              },
            }
          );

          if (data.code === 200) {
            setPopUpKirimChecklist(false);
            setType();
            setDateApar(today);
            setSupplier();
            setKondisi();
            setKadaluarsa(KAD_KOSONG);
            setCheckListIncomingApar(JSON.parse(JSON.stringify(incomingApar)));
            setKeterangan();
          } else {
            setErrorMsg(data.message || "Gagal mengirim data");
            setPopUpKirimChecklist(false);
          }
        } catch (err) {
          console.log("Gagal kirim", err);
          setErrorMsg("Gagal mengirim data, coba lagi");
          setPopUpKirimChecklist(false);
        } finally {
          // selalu stop & bersihkan scanner
          stopScanner();
        }
      };

      const onScanFailed = () => {};
      const config = { fps: 10, qrbox: { width: 250, height: 250 } };
      html5QrCode.start(
        { facingMode: "environment" },
        config,
        qrCodeSuccessCallback,
        onScanFailed
      );
    }
  };

  useEffect(() => {
    if (popUpKirimChecklist) {
      handleScan();
    }
  }, [popUpKirimChecklist]);

  const handleChangeChecksheetApar = (index, event) => {
    let data = [...checkListApar];
    if (index === 12) {
      data[index][event.target.name] = Number(event.target.value);
      setCheckListApar(data);
    } else {
      if (data[index][event.target.name] === true) {
        data[index][event.target.name] = false;
      } else {
        data[index][event.target.name] = true;
      }
      setCheckListApar(data);
    }
  };

  const handleCloseScan = () => {
    const html5QrCode = html5QrCodeRef.current;
    if (html5QrCode) {
      html5QrCode
        .stop()
        .then(() => {
          html5QrCode.clear();
          html5QrCodeRef.current = null;
        })
        .catch((err) => {
          console.log("Error stopping qr code", err);
          html5QrCodeRef.current = null;
        });
    }
    setPopUpKirimChecklist(false);
  };

  useEffect(() => {
    return () => {
      const html5QrCode = html5QrCodeRef.current;
      if (html5QrCode) {
        html5QrCode
          .stop()
          .then(() => {
            html5QrCode.clear();
            html5QrCodeRef.current = null;
          })
          .catch(() => {});
      }
    };
  }, []);

  const handleScanChecksheet = () => {
    if (popUpChecksheet) {
      if (!html5QrCodeRef.current) {
        html5QrCodeRef.current = new Html5Qrcode("qr-checksheet");
      }

      const html5QrCode = html5QrCodeRef.current;

      const qrCodeSuccessCallback = async (decodedText) => {
        if (!decodedText) return;
        html5QrCode.pause();

        try {
          const { data } = await axios.post(
            `${process.env.REACT_APP_ENDPOINT}/checksheetApar`,
            {
              tim: dataUser.tim,
              name: decodedText,
              petugas: dataUser.name,
              checklist: checksheetRef.current,
            },
            {
              headers: {
                Authorization: `Bearer ${dataUser.auth}`,
              },
            }
          );

          if (data.code === 200) {
            setCheckListApar(JSON.parse(JSON.stringify(mock)));
            setPopUpChecksheet(false);
            setSubMenu("Riwayat");
            setIsReload(true);
          }
        } catch (err) {
          console.log("Gagal kirim checksheet", err);
        } finally {
          stopScanner();
        }
      };

      const onScanFailed = () => {};
      const config = { fps: 10, qrbox: { width: 250, height: 250 } };
      html5QrCode.start(
        { facingMode: "environment" },
        config,
        qrCodeSuccessCallback,
        onScanFailed
      );
    }
  };

  useEffect(() => {
    if (popUpChecksheet) {
      handleScanChecksheet();
    }
  }, [popUpChecksheet]);

  useEffect(() => {
    if (subMenu === "Inventory") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getListApar`,
        { tim: dataUser.tim, lantai: "" },
        dataUser.auth,
        setListApar,
        ""
      );
    }
    if (subMenu === "monitoring") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getListApar`,
        { tim: dataUser.tim, lantai: filterLantai },
        dataUser.auth,
        setListStatusApar,
        ""
      );
    }
  }, [subMenu, filterLantai]);

  useEffect(() => {
    if (subMenu === "Riwayat") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getRiwayatApar`,
        {
          tim: dataUser.tim,
          platform: "warehouse",
          filterDate: dateApar,
        },
        dataUser.auth,
        setListRiwayat,
        ""
      );
      setIsReload(false);
    }
  }, [filterMesin, filterType, dateApar, isReload]);

  const searchFeature = () => {
    if (filterType === "Checksheet") {
      if (filterMesin !== "Pilih Apar") {
        let searchName = [];
        listRiwayat &&
          listRiwayat.checksheet.forEach((value) => {
            if (value.noApar === filterMesin) {
              searchName.push(value);
            }
          });
        return searchName;
      } else {
        return listRiwayat && listRiwayat.checksheet;
      }
    } else {
      if (filterMesin !== "Pilih Apar") {
        let searchName = [];
        listRiwayat &&
          listRiwayat.inOut.forEach((value) => {
            if (value.noApar === filterMesin) {
              searchName.push(value);
            }
          });
        return searchName;
      } else {
        return listRiwayat && listRiwayat.inOut;
      }
    }
  };
  // urutkan berdasarkan noApar (numeric-aware, jadi "2" sebelum "10")
  const sortByNoApar = (list) => {
    if (!list) return list;
    const arah = sortApar === "asc" ? 1 : -1;
    return [...list].sort(
      (a, b) =>
        String(a.noApar).localeCompare(String(b.noApar), undefined, {
          numeric: true,
        }) * arah
    );
  };

  let dataTemp = sortByNoApar(searchFeature());
  const listAparSorted = sortByNoApar(listApar);

  return {
    dateApar,
    setDateApar,
    supplier,
    setSupplier,
    kondisi,
    setKondisi,
    checkListIncomingApar,
    handleChangeIncomingApar,
    popUpKirimChecklist,
    setPopUpKirimChecklist,
    handleCloseScan,
    type,
    setType,
    keterangan,
    setKeterangan,
    subMenu,
    setSubMenu,
    filterTahun,
    setFilterTahun,
    filterBulan,
    setFilterBulan,
    checkListApar,
    handleChangeChecksheetApar,
    popUpChecksheet,
    setPopUpChecksheet,
    filterMesin,
    setFilterMesin,
    filterType,
    setFilterType,
    dataTemp,
    kadaluarsa,
    setKadaluarsa,
    tanggalKadaluarsa,
    errorMsg,
    setErrorMsg,
    handleKirimInOut,
    listApar: listAparSorted,
    sortApar,
    setSortApar,
    listStatusApar,
    filterLantai,
    setFilterLantai,
  };
};
